<template>
    <v-layout row wrap m-0>
      <div class="card__header">
          <div class="button__container">
            <div @click="showFilter = !showFilter" class="addProject button__filter" >
              <i class="fas fa-filter "></i>
              <span>Filter</span>
            </div>
            <!-- <div class="page-title px-2 ml-2 d-flex justify-content-between" @click="() => this.$router.push('/newprofile/add-story/step-1')">
              <Button  v-bind="buttonConfig">Add Project</Button>
              <span class="add__plus">+</span>
            </div> -->
            <div class="list__view">
              <span class="grid__btn" :class="{'active-view':isGridView}" @click="hideBtn">
                <svg id="grid__btn" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11.37 11.54"><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path class="cls-1" d="M3,3.34H.33A.33.33,0,0,1,0,3V.33A.33.33,0,0,1,.33,0H3a.33.33,0,0,1,.33.33V3A.33.33,0,0,1,3,3.34Z"/><path class="cls-1" d="M7,3.34H4.35A.34.34,0,0,1,4,3V.33A.34.34,0,0,1,4.35,0H7a.34.34,0,0,1,.34.33V3A.34.34,0,0,1,7,3.34Z"/><path class="cls-1" d="M3,7.36H.33A.34.34,0,0,1,0,7V4.35A.34.34,0,0,1,.33,4H3a.34.34,0,0,1,.33.34V7A.34.34,0,0,1,3,7.36Z"/><path class="cls-1" d="M7,7.36H4.35A.34.34,0,0,1,4,7V4.35A.34.34,0,0,1,4.35,4H7a.34.34,0,0,1,.34.34V7A.34.34,0,0,1,7,7.36Z"/><path class="cls-1" d="M11,3.34H8.36A.34.34,0,0,1,8,3V.33A.34.34,0,0,1,8.36,0H11a.34.34,0,0,1,.34.33V3A.34.34,0,0,1,11,3.34Z"/><path class="cls-1" d="M11,7.36H8.36A.34.34,0,0,1,8,7V4.35A.34.34,0,0,1,8.36,4H11a.34.34,0,0,1,.34.34V7A.34.34,0,0,1,11,7.36Z"/><path class="cls-1" d="M3,11.54H.33A.34.34,0,0,1,0,11.2V8.53a.34.34,0,0,1,.33-.34H3a.34.34,0,0,1,.33.34V11.2A.34.34,0,0,1,3,11.54Z"/><path class="cls-1" d="M7,11.54H4.35A.34.34,0,0,1,4,11.2V8.53a.34.34,0,0,1,.34-.34H7a.34.34,0,0,1,.34.34V11.2A.34.34,0,0,1,7,11.54Z"/><path class="cls-1" d="M11,11.54H8.36A.35.35,0,0,1,8,11.2V8.53a.34.34,0,0,1,.34-.34H11a.34.34,0,0,1,.34.34V11.2A.34.34,0,0,1,11,11.54Z"/></g></g></svg>
                <svg id="list__btn" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.77 9.83"><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path class="cls-1" d="M2,7.87H1a1,1,0,0,0,0,2H2a1,1,0,0,0,0-2ZM2,3.93H1a1,1,0,0,0,0,2H2a1,1,0,0,0,0-2ZM2,0H1A1,1,0,0,0,1,2H2A1,1,0,0,0,2,0ZM5.9,2h6.88a1,1,0,1,0,0-2H5.9a1,1,0,0,0,0,2Zm6.88,2H5.9a1,1,0,0,0,0,2h6.88a1,1,0,1,0,0-2Zm0,3.94H5.9a1,1,0,1,0,0,2h6.88a1,1,0,1,0,0-2Z"/></g></g></svg>
              </span>
              <!-- <span id="list__btn" class="list__btn"  :class="{'active-view':!isGridView}" @click="viewAs(false) && hideBtn"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.77 9.83"><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path class="cls-1" d="M2,7.87H1a1,1,0,0,0,0,2H2a1,1,0,0,0,0-2ZM2,3.93H1a1,1,0,0,0,0,2H2a1,1,0,0,0,0-2ZM2,0H1A1,1,0,0,0,1,2H2A1,1,0,0,0,2,0ZM5.9,2h6.88a1,1,0,1,0,0-2H5.9a1,1,0,0,0,0,2Zm6.88,2H5.9a1,1,0,0,0,0,2h6.88a1,1,0,1,0,0-2Zm0,3.94H5.9a1,1,0,1,0,0,2h6.88a1,1,0,1,0,0-2Z"/></g></g></svg></span> -->
            </div>
            <router-link class="addProject" :to="{name: 'add-story-step-1'}">
              <i class="fas fa-plus-circle "></i>
              <span>Create Project</span>
            </router-link>
            
          </div>
        <v-spacer></v-spacer>
          <!-- <v-flex xs5>
        
            <filters
              @viewAs="viewAs($event)"
              @filterDetails="filterDetails($event)"
              @creationDateFilter="creationDateFilter($event)"
              @creationDateFilterByCustom="creationDateFilterByCustom($event)"
              @sortOrderFilter="sortOrderFilter($event)"
              @organizationSearch="organizationSearch"
              @searchExperienceFilter="searchExperienceFilter"
            >
            </filters>
          </v-flex> -->
          <file-uploader v-model="uploadedProject" @input="uploadProject"
             v-if="$store.state.user.role=='admin' || $store.state.user.role=='developer'">
                <div slot="activator">
                  <button  class="uploadProject" >
                    <i class="fas fa-upload "></i>
                    <span>Upload Project</span>
                  </button>
                </div>
            </file-uploader>
          <SortBy @sort='setSortOrderListView'/>
      </div>
      <!-- GRID VIEW -->
      <div class="gallery_cards_container">
        <div class="filter__card" v-if="showFilter && filtersList.length > 0">
            <GalleryFilter :filtersList="filtersList"/>
        </div>
          <parentListGridCard
            :isGridView="isGridView"
            :search="search"
            :searchByDate="searchByDate"
            :searchDateByCustom="searchDateByCustom"
            :setSortOrder="setSortOrder"
            :list="userStories"
            :organizations="organizations"
            :experienceFilter="experienceFilter"
            :organizationsSideBar="organizationsSideBar"
            :experienceFilterSideBar="experienceFilterSideBar"
            :authorSideBar="authorSideBar"
            :breadCrumbs="breadCrumbs"
            :displayStarredData="displayStarredData"
            :displaySharedData="displaySharedData"
            @editStory="editStory"
            @copyStory="copyStory"
            @sortOrderFilter="sortOrderFilter"
          ></parentListGridCard>
        </div>
    </v-layout>
</template>

<script>
import createStory from '../components/story-list-view/createStory'
import filters from '../components/filters/filters2'
import sideBarFilters from '../components/filters/sideBarFilters'
import parentListGridCard from '../components/story-list-view/parentListGridCard'
import GridCard from '../components/story-list-view/gridCard1'
import ListCard from '../components/story-list-view/listCard1'
import {mapActions} from 'vuex'
import {valueAndGrad} from '@tensorflow/tfjs'
import {db} from '../firebaseDB';
import Button from '../components/global/Button.vue'
import GalleryFilter from '../components/global/sections/GalleryFilter.vue'
import SortBy from '../components/global/sections/SortBy.vue'
import FileUploader from '../components/assets/uploader/fileUploader'

export default {
  name: 'StoryListView',
  // created () {
  //   window.bus.$on('emitListView', (args) => {
  //     this.isList = args.isList
  //   })
  // },

    components: {
    createStory: createStory,
    parentListGridCard: parentListGridCard,
    filters,
    listCard: ListCard,
    gridCard: GridCard,
    sideBarFilters,
    Button,
    GalleryFilter,
    SortBy,
    FileUploader
  },
  data: () => ({
    sortVal : "t-a",
    uploadedProject:{
        fileName: '',
        file: '',
        fileURL: ''
      },
    show: false,
    isGridView: true,
    search: null,
    searchByDate: null,
    setSortOrder: null,
    searchDateByCustom: null,
    organizations: null,
    select: null,
    newText: 'Create New',
    newIcon: 'note_add',
    alignLeft: true,
    story: '',
    experienceFilter: [],
    organizationsSideBar: null,
    authorSideBar: null,
    experienceFilterSideBar: [],
    breadCrumbs: {},
    experienceFilterSideBar: [],
    displayStarredData:null,
    displaySharedData:null,
    buttonConfig : {
    backgroundColor : '#333a43',
    size : "1.2rem"
    },
    showFilter : false,
    filtersList : [
          {
              title : 'Organization',
              name : 'organization',
              icon : 'organization',
              childrens: []
          },
          {
              title : 'Author',
              name : 'author',
              icon : 'author',
              childrens: []
          },
          {
              title : 'Experience',
              name : 'experience',
              icon : 'starred',
              childrens: []
          },
          {
              title : 'Starred',
              name : 'starred',
              icon : !this.starred ? 'starred' :'author',
              childrens: null,
              iconAfter : false,
              toggle : false,
              isStarred : this.starred 
          },
          {
                    title : 'Shared with me',
                    name : 'shared',
                    icon : !this.shared ? 'share' :'author',
                    childrens: null,
                    iconAfter : false,
                    toggle : false,
                    isShared : this.shared 
                },
    ],
  }),
  async created () {
    // this.$store.dispatch('selectedStory', null)
    await this.listUserStories()
  },
  computed: {
    stories () {
      let exStories = ['All']
      console.log('------' + this.$refs.filterDetails.$data)
      this.$store.getters.exsistingStories.forEach((story) =>
        exStories.push(story.title)
      )
      return exStories
    },
    userStories () {
      return this.$store.state.stories
    },
    
  },
  watch: {
    '$store.state.stories'() {
      if (this.$store.state.stories && this.$store.state.stories.length > 0) this.getFilters();
    }
  },
  methods: {
    uploadProject(){
  const fr = new FileReader();
  fr.onload = e => {
    const result = JSON.parse(e.target.result);
    const storiesRef = db.ref().child("stories");   
    let storyKey = storiesRef.push(result).key
    db.ref(`stories/${storyKey}`).once('value').then(snapshot => {
     let uploadedProject =snapshot.val()
     uploadedProject.id=storyKey
     uploadedProject.date = new Date().getFullYear()  + '-' +
                            (new Date().getMonth() + 1) + '-' +
                            new Date().getDate()
     uploadedProject.title=snapshot.val().title+'_uploaded'  
     if(uploadedProject.json){
     uploadedProject.json.storyName=snapshot.val().title+'_uploaded'  
     }
     db.ref().child(`stories/${storyKey}`).update(uploadedProject)
      })
  }
  fr.readAsText(this.uploadedProject.file);
 },
    hideBtn() {
      const grid__btn = document.getElementById('grid__btn');
      const list__btn = document.getElementById('list__btn');

      if (this.isGridView == true) {
        this.viewAs(false);
        grid__btn.style.display = 'none';
        list__btn.style.display = 'block';
      }
      else {
        this.viewAs(true);
        list__btn.style.display = 'none';
        grid__btn.style.display = 'block';
      }
    },
    getFilters() {
      let stories = [];
        Object.assign(stories,this.$store.state.stories)
        for (const story of stories) {
            const { organization, author, experience }  = { ...story }
            if(organization && this.filtersList && this.filtersList[0] && this.filtersList[0].childrens && this.filtersList[0].childrens.indexOf(organization) == -1) this.filtersList[0].childrens.push(organization);
            if(author && this.filtersList && this.filtersList[1] && this.filtersList[1].childrens && this.filtersList[1].childrens.indexOf(author) == -1) this.filtersList[1].childrens.push(author);
            if(experience && experience.type && this.filtersList && this.filtersList[2] && this.filtersList[2].childrens && this.filtersList[2].childrens.indexOf(experience.type) == -1) this.filtersList[2].childrens.push(experience.type);
        } 
    },
    ...mapActions(['listUserStories']),
    listView () {
      this.isList = !this.isList
    },
    filterDetails (search) {
      this.search = search
    },
    creationDateFilter (search) {
      this.searchByDate = search
    },
    creationDateFilterByCustom (searchDateByCustom) {
      this.searchDateByCustom = searchDateByCustom
    },
    setSortOrderListView (value) {
      if(value == "title") {this.sortVal = this.sortVal ? this.sortVal == "t-d" ? "t-a" : "t-d" : "t-d";}
      if(value == "author") {this.sortVal = this.sortVal ? this.sortVal == "a-d" ? "a-d" : "a-d" : "a-d";}
      if(value == "updated_at") {this.sortVal = this.sortVal ? this.sortVal == "d-d" ? "d-a" : "d-d" : "d-d";}
      this.sortOrderFilter(this.sortVal)
    },
    sortOrderFilter (value) {
      console.log("sort",value);
      this.setSortOrder = value
    },
    viewAs (val) {
      this.isGridView = val
    },
    editStory (story) {
      this.story = story
    },
    async copyStory (story) {
      await db
        .ref()
        .child('stories/' + story.id)
        .once('value')
        .then((value) => {
          if (value.key === story.id) {
            let data = value.val()
            data.id = ''
            data.title = ''
            data.date = ''
            this.story = data
          }
        })
    },
    async emptyEditStory () {
      this.story = ''
      await this.listUserStories()
    },
    organizationSearch (value) {
      this.organizations = value
    },
    searchExperienceFilter (data) {
      this.experienceFilter = data
    },
    organizationSearchSideBar (value) {
      this.organizationsSideBar = value
    },
    searchExperienceFilterSideBar (data) {
      this.experienceFilterSideBar = data
    },
    displayStarred (data) {
       this.displayStarredData = data;
    },
    displayShared (data) {
       this.displaySharedData = data;
       console.log('ffffffffff')
    },
  },

}
</script>

<style lang="scss" scoped>
    a {
      text-decoration: none;
    }
    .addProject,.uploadProject {
      position: relative;
      text-decoration: none;
      text-transform: uppercase;
      background-color: #7367F0;
      box-shadow: 0 3px 6px 0 #7367f066;
      color: white;
      height: 4rem;
      display: var(--uismLinkDisplay);
      transition-duration: 0.4s;
      overflow: hidden;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      margin: 0 0.3rem;
      padding: 0.3rem 0.5rem;
      border-radius: 0.2rem;
      -webkit-transition: .3s;
      transition: .3s;
      font-weight: 700;
      cursor: pointer;

      i {
        margin-right: 5px;
      }

      &:nth-child(1) {
        margin-left: 0;
      }

      &:hover {
      background-color: #7367F0;
      box-shadow: 0 3px 6px 0 #7367f066;
      }
    }
    #list__btn {
      display: none;
    }
    .theme--light.v-divider {
      border-color: rgba(170, 170, 170, 1);
    }
    .page-title {
        background-color: #333a43 !important;
        /* border-radius: 15px 15px 0px 0px; */
        color: white;
        width: 240px;
        align-items:center;
        padding : .5rem;
        font-size : 1.5rem;
        cursor: pointer;
    }
    
    .button__filter {
      width: 8rem;
      height: 4rem;
    }
    .button__container {
      display: flex;
      align-items: center;
      padding: 1rem 1.5rem 1rem 0;
      
    }
    .side-button {
      border-radius: 50%;
      background-color: #4d66b1;
      /* position: relative; */
      /* left: 20px;
      top: 6px; */
      border: white solid 3px;
      /* padding : .5rem 0; */
    }
    .add__plus {
      padding : .8rem .5rem;
      background-color: #7367F0;
      box-shadow: 0 3px 6px 0 #7367f066;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 1.2rem;
    }
    .card__header {
      display: flex;
      align-items: center;
      justify-content: space-evenly;
      width : 100%;
    }

    .filter__card {
      min-width: 17.2rem;
      overflow : hidden;
      margin-right: 1rem;
      margin-top: 12px;
    }
    .gallery_cards_container {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      width : 100%;
      padding: 0;
    }
    .gellery__cards {
      display: contents;
      width: 100%;
      height: 100%;
      box-shadow: #e5e5e526 5px 5px 1px;
      background-color : transparent;
      
    }
    .grid_view {
      border: .1rem solid #b6cad8;
      padding : 1.5rem;
      background-color: #ffffff;
      border-radius: .5rem;
      

    }
    .left__bloc__container {
      display : flex;
      align-items:center;
    }
    .list__view {
      display: flex;
      align-items: center;
      justify-content: center;
        svg {
        width : 1rem;
        height : 1rem;
        fill : currentColor;
      }
    }
    .grid__btn, .list__btn {
      height: 4rem;
    width: 4rem;
    display: flex;
    align-items: center;
    justify-content: center;
      margin : 0 .3rem;
      padding : .3rem .5rem;
      cursor: pointer;
      background-color: #333a43;
      color : white;
      border-radius : .2rem;
      transition : .3s;
    }
    .grid__btn svg, .list__btn svg{
    height: 60%;
    width: 50%;
  }
    .grid__btn:hover, .list__btn:hover {
      background-color : #7367F0;
      box-shadow: 0 3px 6px 0 #7367f066;
    }
    .active-view {
      background-color : #7367F0;
      box-shadow: 0 3px 6px 0 #7367f066;
    }
    
  @media  (max-width: 820px) {
  .card__header {
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
  }
  .gallery_cards_container {
    flex-direction: column;
    
  }
  .grid__btn, .list__btn {
    height: 4rem;
    width: 4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    order: -1;
    margin: 0 ;
  }
  .grid__btn svg, .list__btn svg{
    height: 60%;
    width: 50%;
  }
  .addProject,.uploadProject {
    order: 2;
    width: 100%;
  }
  .list__view {
    order: 3;
  }
  .filter__card {
    margin: 0;
    width: 100%;
    margin-bottom: 0px;
    margin-top: 1rem;
  }
  .button__filter{
    width: 80px !important;
    height: 56px !important;
    order: 1;
    margin: 0;

    span {
      display: none;
    }
    i {
      margin-right: 0;
    }
  }
  .page-title button {
    font-size: 0px !important;
  }
  .main_container .content_mc_wrp {
    padding: 0px 5px 75px 0;
  }
  .button__container {
      justify-content: space-between;
      width: 100%;
      padding: 1rem 0;
    }
  .notForMobile {
    display: none;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/StoryListView.vue